// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { findLocationModalStyles } from "@awc/Overrides/Components/FindLocationModal";
import { color, xScreen } from "@awc/XDL/Utilities";
import { RadioStyle } from "@insite/mobius/Radio";
import { css } from "styled-components";

findLocationModalStyles.distanceUnitOfMeasureRadioGroup = {
    horizontal: true,
    css: css`
        display: flex;
        width: 100%;
        flex-direction: row;
        gap: 20px;
        justify-content: end;
        && > ${RadioStyle} {
            display: inline-flex;
            margin-right: 0;
        }
    `,
};

findLocationModalStyles.searchResultsText = {
    css: css``,
};

findLocationModalStyles.searchResultGridItem = {
    width: 12,
    css: css`
        padding-top: 4px;
    `,
};

findLocationModalStyles.paginationGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        padding-top: 16px;
    `,
};

findLocationModalStyles.warehouseGoogleMapsDirectionLink = {
    css: css`
        height: 100%;
    `,
};

findLocationModalStyles.searchResultHoursGridItem = {
    width: 10,
};

findLocationModalStyles.searchResultHoursOffsetGridItem = {
    width: 2,
    css: css`
        justify-content: center;
    `,
};

findLocationModalStyles.searchResultHoursIcon = {
    color: "primary",
};

findLocationModalStyles.searchResultGoogleMapsDirectionLinkGridItem = {
    width: [10, 4, 4, 4, 4],
};

findLocationModalStyles.searchResultDistanceGridItem = {
    width: [10, 6, 6, 6, 6],
};

findLocationModalStyles.searchResultLinksOffsetMobileGridItem = {
    width: [2, 0, 0, 0, 0],
};

findLocationModalStyles.searchResultDivider = {
    css: css`
        margin: 16px 0;
        border: 1px solid ${color("common.border")};
        width: 100%;
    `,
};

findLocationModalStyles.selectedWarehouseDetailsGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

findLocationModalStyles.selectedWarehouseLinksGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

findLocationModalStyles.searchResultAddressInfoIcon = {
    size: 14,
    color: "primary",
    css: css`
        padding-top: 8px;
    `,
};

findLocationModalStyles.searchResultPhoneIcon = {
    size: 14,
    color: "primary",
};

findLocationModalStyles.searchResultHoursIcon = {
    size: 14,
    color: "primary",
};

findLocationModalStyles.searchResultPhoneLink = {};

findLocationModalStyles.searchResultSelectButton = {
    variant: "primary",
    css: css`
        margin-right: 0;
        margin-left: auto;
    `,
};

findLocationModalStyles.searchButton = {
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

findLocationModalStyles.searchButtonGridItem = {
    width: [12, 12, 12, 4, 4],
    css: css`
        padding-top: 10px;
        display: flex;
        justify-content: end;
        align-items: end;
    `,
};

findLocationModalStyles.searchResultLeftGridItem = {
    width: 8,
};

findLocationModalStyles.searchResultSelectGridItem = {
    width: 4,
};

findLocationModalStyles.searchResultsTextGridItem = {
    ...findLocationModalStyles.searchResultsTextGridItem,
    css: css`
        padding-top: 10px;
    `,
};

findLocationModalStyles.distanceUnitOfMeasureGridItem = {
    ...findLocationModalStyles.distanceUnitOfMeasureGridItem,
    css: css`
        padding-top: 10px;
    `,
};
